import Api from '~/Api';

class VersionUpdater {
  checkUpdateIntervalMin = 20; // default 20 minutes
  checkUpdateInterval: number | null = null;
  currentVersion: string | null = null;
  private isVersionCheckEnabled = true;

  init({ currentVersion }: { currentVersion: string }): void {
    this.currentVersion = currentVersion;
    if (currentVersion === 'unknown') {
      this.isVersionCheckEnabled = false;
      return;
    }
    this.run();
  }

  private run(): void {
    if (this.checkUpdateInterval || !this.isVersionCheckEnabled) {
      return;
    }
    this.checkUpdateInterval = window.setInterval(
      async () => {
        try {
          await this.performVersionCheck();
        } catch (error) {
          console.error('Version check failed:', error);
        }
      },
      this.checkUpdateIntervalMin * 60 * 1000,
    );
  }

  private async performVersionCheck(): Promise<void> {
    const versionInfo = await this.getLastVersion();
    if (!versionInfo) return;
    const { version, shouldUpdate } = versionInfo;
    if (shouldUpdate && version !== this.currentVersion) {
      this.handleVersionUpdate();
    }
  }

  private async getLastVersion(): Promise<{
    version: string;
    shouldUpdate: boolean;
  } | null> {
    try {
      const { github_sha, need_update } = await Api.getVersion();
      if (github_sha === 'unknown') {
        return null;
      }
      return {
        version: github_sha,
        shouldUpdate: need_update,
      };
    } catch (error) {
      console.error('Failed to get version info:', error);
      return null;
    }
  }

  private handleVersionUpdate(): void {
    window.location.reload();
  }

  stop(): void {
    if (this.checkUpdateInterval) {
      clearInterval(this.checkUpdateInterval);
      this.checkUpdateInterval = null;
    }
  }

  get isRunning(): boolean {
    return this.checkUpdateInterval !== null;
  }

  get status(): {
    isEnabled: boolean;
    isRunning: boolean;
    currentVersion: string | null;
    intervalMinutes: number;
  } {
    return {
      isEnabled: this.isVersionCheckEnabled,
      isRunning: this.isRunning,
      currentVersion: this.currentVersion,
      intervalMinutes: this.checkUpdateIntervalMin,
    };
  }
}

const versionUpdater = new VersionUpdater();

export default versionUpdater;
